import './App.css'
import theme from './styles/theme'
import { QueryClient, QueryClientProvider } from 'react-query'
import { Notifications } from 'react-push-notification';
import { ThemeProvider } from 'styled-components'
import { MainProvider } from './context/MainContext/MainContext'
import { GrowthProvider } from './context/GrowthContext/GrowthContext'
import { PlantProvider } from './context/PlantContext/PlantContext'
import { PointProvider } from './context/PointContext/PointContext'
import AppRoutes from './AppRoutes'
import { DefexProvider } from './context/DefexContext/DefexContext';


const queryClient = new QueryClient()

function App() {
  return (
    <ThemeProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <MainProvider>
          <Notifications />
          <GrowthProvider>
            <PlantProvider>
              <PointProvider>
                <DefexProvider>
                  <AppRoutes />
                </DefexProvider>
              </PointProvider>
            </PlantProvider>
          </GrowthProvider>
        </MainProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;
